import { c as _c } from "react/compiler-runtime";
import type { AdvancedMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { Field, Fieldset, Label } from '@algoacademy/design-system/web/forms/Fieldset';
import { Input } from '@algoacademy/design-system/web/forms/Input';
import { Slider } from '@algoacademy/design-system/web/forms/Slider/Slider';
import { Switch } from '@algoacademy/design-system/web/forms/Switch';
import { H4 } from '@algoacademy/design-system/web/marketing/typography/Heading/H4';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph/P2';
import { useState } from 'react';
import { cn } from '@/app/_lib/utils';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
import { MAXIMUM_LINES_OF_CODE, MINIMUM_LINES_OF_CODE } from '../../../prices';
type CodeInspectionProps = {
  advancedMentoringProduct: AdvancedMentoringProductDTO;
  updateProduct: (updates: Partial<AdvancedMentoringProductDTO> | ((prev: AdvancedMentoringProductDTO) => Partial<AdvancedMentoringProductDTO>)) => void;
};
export function CodeInspection(t0) {
  const $ = _c(19);
  const {
    advancedMentoringProduct,
    updateProduct
  } = t0;
  const linesOfCode = advancedMentoringProduct.linesOfCode;
  const [isCodeInspectionOpen, setIsCodeInspectionOpen] = useState(linesOfCode > 0);
  const t1 = !isCodeInspectionOpen && "text-slate-400";
  let t2;
  if ($[0] !== t1) {
    t2 = cn(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <H4 className="font-medium">Inspekcja kodu</H4>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== updateProduct) {
    t4 = () => {
      setIsCodeInspectionOpen(_temp);
      updateProduct(_temp2);
    };
    $[3] = updateProduct;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isCodeInspectionOpen || $[6] !== t4) {
    t5 = <div className="flex items-center justify-between">{t3}<Switch checked={isCodeInspectionOpen} onChange={t4} /></div>;
    $[5] = isCodeInspectionOpen;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <P2 className="text-contentSecondary">Mentor przejrzy Twój kod i dostarczy szczegółowe uwagi dotyczące jakości, architektury i najlepszych praktyk programistycznych.</P2>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isCodeInspectionOpen || $[10] !== linesOfCode || $[11] !== updateProduct) {
    t7 = isCodeInspectionOpen && <div className="flex flex-col items-end gap-1 sm:flex-row sm:gap-6"><div className="flex w-full flex-1 flex-col gap-2"><Slider variant="single" min={MINIMUM_LINES_OF_CODE} max={MAXIMUM_LINES_OF_CODE} step={1000} value={[linesOfCode]} onValueChange={value => updateProduct({
          linesOfCode: value[0]
        })} /><div className="flex justify-between text-slate-600 text-sm"><p>{MINIMUM_LINES_OF_CODE} linii</p><p>{MAXIMUM_LINES_OF_CODE} linii</p></div></div><Fieldset className="w-36 self-center"><Field><Label>Liczba linii kodu</Label><Input readOnly={true} value={linesOfCode} type="number" step={1000} /></Field></Fieldset></div>;
    $[9] = isCodeInspectionOpen;
    $[10] = linesOfCode;
    $[11] = updateProduct;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <div className="space-y-6 sm:space-y-2">{t6}{t7}</div>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t5 || $[17] !== t8) {
    t9 = <IconOnTheLeftWithContentLayout className={t2} mainContent={t5}>{t8}</IconOnTheLeftWithContentLayout>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}
function _temp2(prev_0) {
  return {
    linesOfCode: prev_0.linesOfCode > 0 ? 0 : MINIMUM_LINES_OF_CODE
  };
}
function _temp(prev) {
  return !prev;
}